import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Bangalore() {
  const [openFaq, setOpenFaq] = useState(null);
  const navigate = useNavigate();

  const faqs = [
    {
      q: "How can I book a self drive car in Bangalore with Wow carz?",
      a: "Booking is simple: visit the website or app, choose your car, select a package (hourly/daily/weekly or 100 km trip), and confirm. You'll receive a booking confirmation and pickup details.",
    },
    {
      q: "What documents are required to rent a car in Bangalore?",
      a: "You need a valid driving license (minimum age 21 and at least 1 year of driving history) and a government-issued ID (Aadhar or Passport).",
    },
    {
      q: "Can I rent a car for a short trip within the city?",
      a: "Yes — Wow carz offers hourly, daily and monthly packages suitable for city travel, shopping, meetings, and short outings.",
    },
    {
      q: "Is it possible to take the rental car outside Bangalore?",
      a: "Yes — choose the appropriate outstation package to drive to nearby destinations like Nandi Hills, Mysore, Coorg and more. Check package details for kilometer limits and charges.",
    },
    {
      q: "Why should I choose Wow carz over other car rental services in Bangalore?",
      a: "Wow carz provides hassle-free booking, competitive pricing, well-maintained cars and 24/7 support — giving you freedom to travel at your own pace.",
    },
    {
      q: "Are Wow carz rentals available for both short and long durations?",
      a: "Yes — you can book hourly packages for short trips or daily/weekly rentals for long trips and weekend getaways.",
    },
  ];

  const places = [
    {
      image: "/assets/lalbarghbangalore.jpg",
      title: "Lalbagh Botanical Garden",
      desc: "A paradise for nature lovers, Lalbagh is famous for its glasshouse and wide variety of flora. Perfect for a peaceful morning drive with your self drive car rental in Bangalore.",
    },
    {
      image: "/assets/cubbonpark.jpg",
      title: "Cubbon Park",
      desc: "Located in the heart of the city, Cubbon Park is ideal for an evening stroll, cycling, or a short trip with family. Parking your self drive car in Bangalore nearby is easy and convenient.",
    },
    {
      image: "/assets/bangalorepalace.jpg",
      title: "Bangalore Palace",
      desc: "A royal landmark that resembles Windsor Castle in England. A must-visit if you’re planning a trip within the city with your Wow carz self drive rental.",
    },
    {
      image: "/assets/nandhihills.jpg",
      title: "Nandi Hills (60 km from Bangalore)",
      desc: "Perfect for a sunrise drive, Nandi Hills is the most popular spot for a trip within 100 kms. With a self drive car rental in Bangalore, you can enjoy a scenic early morning ride without any hassle.",
    },
    {
      image: "/assets/bannerhattanationalpark.jpg",
      title: "Bannerghatta National Park",
      desc: "Just a short trip from the city, Bannerghatta offers a wildlife safari and butterfly park – a great destination for families traveling with a rental car.",
    },
    {
      image: "/assets/commercialstreet.jpg",
      title: "Commercial Street & Brigade Road",
      desc: "If shopping excites you, then these streets are a must-visit. With a Wow carz self drive car in Bangalore, you can explore the shopping hubs and carry your bags back with ease.",
    },
  ];

  const whyCards = [
    {
      title: "Seamless Booking",
      text: "Reserve your car in just a few clicks and hit the road without any hassle.",
    },
    {
      title: "Reliable & Safe",
      text: "Our fleet is regularly maintained for your safety and comfort during every trip.",
    },
    {
      title: "Flexible Packages",
      text: "Choose from hourly, daily, or long-trip plans that fit your travel needs perfectly.",
    },
    {
      title: "Explore Nearby Destinations",
      text: "Whether it’s Nandi Hills, Mysore, or Coorg, Wow Carz takes you anywhere you wish to go.",
    },
    {
      title: "24/7 Support & Delivery",
      text: "Pick up your car from the airport, railway station, or doorstep anytime, anywhere.",
    },
  ];

  // Slider settings
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1, arrows: false },
      },
    ],
  };

  return (
    <div className="min-h-screen bg-gray-50 text-gray-800 font-inter">
      {/* Header */}
      <header className="bg-pink-100 shadow-sm sticky top-0 z-20">
        <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
          <div className="flex-shrink-0">
            <img
              onClick={() => navigate("/")}
              loading="lazy"
              style={{ height: 55, width: 160 }}
              src="https://bagzpack.s3.amazonaws.com/logo/68ea80da-f61b-4333-a4ed-ebae07c63893/IMG/1645694302682.png"
              alt="wowcarzlogo"
              className="object-cover cursor-pointer"
            />
          </div>

          <div className="flex items-center gap-3">
            <a
              href="/"
              className="bg-pink-400 text-white px-4 py-2 rounded-lg shadow hover:bg-pink-500 transition"
            >
              Book Now
            </a>
            <a
              href="tel:+919844300066"
              className="inline-flex items-center gap-2 border border-gray-200 px-3 py-2 rounded-lg text-sm hover:bg-gray-100 transition"
            >
              📞 Call Us
            </a>
          </div>
        </div>
      </header>

      <main className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        {/* Hero */}
        <section className="relative rounded-2xl h-[500px] sm:h-[550px] lg:h-[600px] overflow-hidden">

          <img
            src="/assets/bnglr.jpg"
            alt="Self Drive Cars Chennai"
            className="absolute inset-0 w-full h-full object-contain scale-125"
          />
          <div className="absolute inset-0 bg-black/50 flex flex-col justify-center items-center text-center px-6 sm:px-12">
            <h2 className="text-3xl sm:text-5xl font-bold text-white mb-4">
              Self Drive Cars in Bangalore
            </h2>

            <p className="text-gray-200 text-base sm:text-lg max-w-xl leading-relaxed">
              Book your ride in minutes with Wow Carz. Affordable, convenient
              and reliable travel — your car, your way.
            </p>
          </div>
        </section>

        {/* Explore Section */}
        <section className="bg-pink-50 p-4 m-3">
          <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-3xl p-8 sm:p-12 text-center">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-6">
              Explore Bangalore with Wow Carz
            </h2>
            <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
              Looking for a self drive car in Bangalore to make your travel
              smooth and stress-free? <strong>Wow Carz</strong> offers the most reliable and
              affordable self drive car rental in Bangalore, designed for your
              short trips, long trips, or even a quick trip within 100 kms.
              Whether it’s for a business meeting, a family outing, or a weekend
              getaway, we’ve got you covered with our wide range of rental cars.
            </p>
          </div>
        </section>

        {/* Why Rent Section (Slider) */}
        <section className="py-12 bg-gray-50">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-10 text-gray-900">
            Why Rent With Wow Carz?
          </h2>
          <Slider {...sliderSettings} className="px-6 [&_.slick-dots]:left-0">
            {whyCards.map((card, i) => (
              <div key={i} className="px-3">
                <div className="bg-white rounded-2xl shadow-lg p-6 text-center hover:shadow-xl transition">
                  <h3 className="text-xl font-semibold mb-2">{card.title}</h3>
                  <p className="text-gray-600 text-sm">{card.text}</p>
                </div>
              </div>
            ))}
          </Slider>
        </section>

        {/*plan your trip */}
        <section className="p-4 bg-pink-200 m-3">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-3xl sm:text-4xl font-bold mb-12 text-gray-900">
              Plan Your Trip to Bangalore
            </h2>

            {(() => {
              const cards = [
                {
                  icon: "🏙️",
                  iconBg: "bg-purple-100",
                  title: "Interesting Facts About Bangalore",
                  desc: (
                    <>
                      Bangalore, also known as <strong>Bengaluru</strong>, is the capital of{" "}
                      <strong>Karnataka</strong> and a hub of technology, gardens, and culture.
                      Known as the <strong>“Garden City of India”</strong>, it features famous
                      landmarks like <strong>Lalbagh Botanical Garden</strong> and{" "}
                      <strong>Bangalore Palace</strong>, making it perfect for sightseeing
                      and weekend trips.
                    </>
                  ),
                },
                {
                  icon: "🎉",
                  iconBg: "bg-red-100",
                  title: "Famous Festivals in Bangalore",
                  desc: (
                    <>
                      Bangalore hosts a variety of vibrant festivals. Major celebrations
                      include <strong>Karaga Festival</strong>, <strong>Dasara</strong>,{" "}
                      <strong>Pongal</strong>, and the{" "}
                      <strong>Bangalore International Film Festival</strong>. These events
                      offer tourists cultural insights, entertainment, and a lively city
                      experience.
                    </>
                  ),
                },
                {
                  icon: "🌤️",
                  iconBg: "bg-yellow-100",
                  title: "Best Time to Visit Bangalore",
                  desc: (
                    <>
                      Bangalore enjoys a pleasant climate throughout the year, making it
                      ideal for sightseeing and self-drive trips. Temperatures usually
                      range between 20°C – 30°C, allowing you to comfortably explore city
                      attractions like <strong>Lalbagh Botanical Garden</strong>,{" "}
                      <strong>Cubbon Park</strong>, <strong>Nandi Hills</strong>, and nearby
                      weekend getaways anytime you visit.
                    </>
                  ),
                },
              ];

              return (
                <>
                  {/* Desktop Grid */}
                  <div className="hidden md:grid grid-cols-1 md:grid-cols-3 gap-8">
                    {cards.map((card, i) => (
                      <div
                        key={i}
                        className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300"
                      >
                        <div
                          className={`w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full text-2xl ${card.iconBg}`}
                        >
                          {card.icon}
                        </div>
                        <h3 className="text-xl font-semibold mb-4">{card.title}</h3>
                        <p className="text-gray-700 leading-relaxed text-sm">{card.desc}</p>
                      </div>
                    ))}
                  </div>

                  {/* Mobile Carousel */}
                  <div className="block md:hidden">
                    <Slider {...sliderSettings}>
                      {cards.map((card, i) => (
                        <div key={i} className="px-3">
                          <div className="bg-white p-8 rounded-2xl shadow-lg text-center">
                            <div
                              className={`w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full text-2xl ${card.iconBg}`}
                            >
                              {card.icon}
                            </div>
                            <h3 className="text-xl font-semibold mb-4">{card.title}</h3>
                            <p className="text-gray-700 leading-relaxed text-sm">
                              {card.desc}
                            </p>
                          </div>
                        </div>
                      ))}
                    </Slider>
                  </div>
                </>
              );
            })()}
          </div>
        </section>

        {/* Top Places Section (Slider) */}
        <section className="mt-12">
          <h3 className="text-2xl font-semibold text-gray-900 mb-2 text-center">
            Top Places to Visit in Bangalore
          </h3>
          <p className="text-gray-600 mb-6 text-center">
            Perfect for day trips and weekend getaways with your Wow Carz ride.
          </p>
          <Slider {...sliderSettings} className="px-6 [&_.slick-dots]:left-0">
            {places.map((place) => (
              <div key={place.title} className="px-3">
                <article className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl border border-gray-100 text-center transition">
                  <img
                    className="w-48 h-48 object-cover rounded-xl mx-auto mb-4"
                    src={place.image}
                    alt={place.title}
                  />
                  <h4 className="font-semibold text-lg mb-2">{place.title}</h4>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {place.desc}
                  </p>
                </article>
              </div>
            ))}
          </Slider>
        </section>



        {/* FAQ */}
        <section className="mt-16">
          <h3 className="text-2xl font-semibold text-gray-900 mb-4 text-center">
            Frequently Asked Questions
          </h3>
          <div className="space-y-4">
            {faqs.map((f, i) => (
              <div
                key={i}
                className="border rounded-xl bg-white shadow-sm overflow-hidden"
              >
                <button
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                  className="w-full text-left px-5 py-4 flex items-center justify-between hover:bg-gray-50 transition"
                >
                  <span className="font-medium text-gray-800">{f.q}</span>
                  <span className="text-gray-500 text-lg">
                    {openFaq === i ? "−" : "+"}
                  </span>
                </button>
                <div
                  className={`px-5 overflow-hidden transition-all duration-300 ${openFaq === i ? "max-h-40 py-3" : "max-h-0"
                    }`}
                >
                  <p className="text-gray-700 text-sm leading-relaxed">{f.a}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section className="mt-16 bg-gradient-to-r from-pink-400 via-pink-500 to-pink-600 text-white p-8 rounded-3xl flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="text-center sm:text-left">
            <h4 className="text-2xl font-semibold">
              Ready to Start Your Journey?
            </h4>
            <p className="text-sm mt-2 text-blue-100">
              Experience hassle-free driving with Wow Carz today.
            </p>
          </div>
          <div className="flex gap-3">
            <a
              href="/"
              className="bg-white text-blue-600 px-6 py-3 rounded-lg font-medium hover:bg-blue-100 transition"
            >
              Book Now
            </a>
            <a
              href="tel:+919844300066"
              className="border border-white px-6 py-3 rounded-lg hover:bg-white hover:text-blue-600 transition"
            >
              Call Us
            </a>
          </div>
        </section>

        {/* Footer */}
        <footer className="mt-10 text-center text-sm text-gray-500">
          © {new Date().getFullYear()} Wow Carz — All rights reserved
        </footer>
      </main>
    </div>
  );
}

export default Bangalore;
